<button 
  class="locator-button" 
  mat-flat-button color="primary"
  type="submit"
  (click)="clicked.emit()"
  [disabled]="disabled"
  >
  <mat-icon>{{icon}}</mat-icon>
  {{labelText}}
</button>